/** A small ring spinner. Pass `label` for the common "Spinner + text" row;
 *  bare (no label) for inline use inside a stat tile. */
export default function Spinner({
  label,
  size = 16,
}: {
  label?: string;
  size?: number;
}) {
  return (
    <span className="spinner-wrap" role="status">
      <span
        className="spinner"
        style={{ width: size, height: size, borderWidth: Math.max(2, Math.round(size / 8)) }}
        aria-hidden
      />
      {label && <span className="spinner-label">{label}</span>}
      <span className="sr-only">{label ?? 'Loading'}</span>
    </span>
  );
}
